import { render } from "./viewLessonDiscuss.vue?vue&type=template&id=110ef6cf&scoped=true"
import script from "./viewLessonDiscuss.vue?vue&type=script&lang=js"
export * from "./viewLessonDiscuss.vue?vue&type=script&lang=js"

import "./viewLessonDiscuss.vue?vue&type=style&index=0&id=110ef6cf&scoped=true&lang=css"

import exportComponent from "E:\\edu-ui\\LyEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-110ef6cf"]])

export default __exports__